import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OTPConfig } from 'src/app/Models/otpConfig';
import { NotificationService } from 'src/app/Service/notification.service';
import { DashBoardService } from 'src/app/User/Pages/dash-board/dash-board.service';
import { MyProfileService } from 'src/app/User/Pages/my-profile/my-profile.service';
@Component({
    selector: 'app-vaultauthentication',
    templateUrl: './vault-authentication.component.html',
    styleUrls: ['./vault-authentication.component.css'],
    standalone: false
})
export class VaultAuthenticationComponent implements OnInit {
  OtpResp: any;
  isAccessGranted: boolean = false;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInputs: any;
  @Output() validate = new EventEmitter<any>();
  constructor(
    public dashBoardService: DashBoardService,
    private notification: NotificationService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public myProfileService: MyProfileService
  ) {
    this.myProfileService.GetProfile().toPromise();
  }
  ngOnInit(): void {
    this.getCode();
  }
  getCode(resend = false) {
    this.dashBoardService.GetAccessCode().subscribe((info) => {
      this.OtpResp = info.data;
      if (resend) {
        this.notification.showInfo(
          'A 6-digit security code has been sent to your phone number.'
        );
      }
    });
  }
  public otpconfig: OTPConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '40px',
      height: '40px',
      padding:'0px',
    },
  };
  onClose() {
    this.activeModal.dismiss(false);
  }
  onOtpChange(otp) {
    if (otp.length == 6) {
      const data = {
        Id: this.OtpResp.interactionId,
        Otp: otp,
      };
      this.dashBoardService.PostValidateCode(data).subscribe((res) => {
        if (res.data) {
          this.isAccessGranted = true;
          setTimeout(() => {
            this.validate.emit(true);
            this.modalService.dismissAll(true);
          }, 2500);
        } else {
          this.notification.showWarning(
            'You entered an invalid security code. Please try again. '
          );
        }
      });
    }
  }
  getMasked(phone) {
    if (phone) return phone.replace(/\d{5}(\d*)/, '*****$1');
  }
}
